var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.521484,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.521484,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6941 23.2146C18.2478 23.6609 18.2478 24.3856 18.6941 24.8319L25.5489 31.6868C25.9952 32.1331 26.72 32.1331 27.1662 31.6868C27.6125 31.2405 27.6125 30.5157 27.1662 30.0695L21.1183 24.0215L27.1627 17.9735C27.609 17.5272 27.609 16.8025 27.1627 16.3562C26.7164 15.9099 25.9916 15.9099 25.5454 16.3562L18.6905 23.211L18.6941 23.2146Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-left.ccec9df0700415cbc8334de213e4618c.svg";
export { ForwardRef as ReactComponent };